import CanShow from "./CanShow.jsx";
import Statistics from "@/features/dashboard/statistics/Index.jsx";
import Dashboard from "@/features/dashboard/advanced-statistics/Index.jsx";
import { Navigate } from "@";

export const dashboardRoutes = [
  {
    path: "/",
    element: <Navigate to="/statistics" />,
  },
  {
    path: "/statistics",
    element: <CanShow page={<Statistics />} ifHas={["statistics"]} />,
  },
  {
    path: "/advanced-statistics",
    element: <CanShow page={<Dashboard />} ifHas={["statistics"]} />,
  },
];
